export const YesNoToBool = (str: string) => {
  return str === 'Да';
};
